var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.title))]),
              ]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm.innerValue
                ? _c("image-select", {
                    attrs: {
                      "quote-id": _vm.quoteId,
                      "is-loading": _vm.isLoadingImages,
                    },
                    on: {
                      "update:isLoading": function ($event) {
                        _vm.isLoadingImages = $event
                      },
                      "update:is-loading": function ($event) {
                        _vm.isLoadingImages = $event
                      },
                    },
                    model: {
                      value: _vm.selectedImages,
                      callback: function ($$v) {
                        _vm.selectedImages = $$v
                      },
                      expression: "selectedImages",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Submit parts",
                    disabled: _vm.isLoadingImages,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-upload" }),
                  ]),
                  _c("span", [_vm._v("Attach")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }